import { AxiosPromise } from 'axios';
import { axiosRef } from '.';
import {
  AnnouncementApiParams,
  AnnouncementsApiResponse,
} from '../types/api/announcements';

export const fetchAnnouncements = async (
  params: AnnouncementApiParams
): Promise<AxiosPromise<AnnouncementsApiResponse>> => {
  let url = '/announcements';

  if (params) {
    let queryParams = '';
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        queryParams += `${key}=${value}&`;
      }
    });
    if (queryParams) {
      url += `?${queryParams.slice(0, -1)}`;
    }
  }

  return axiosRef.get(url.toString());
};
